<template>
    <section class="t-scroll" data-hf-pin ref="track">
        <div class="testimonials" ref="panel">
            <div class="head">
                <h2>
                    <span>{{ translateWord('Negócios Reais. Resultados Reais.') }}</span>
                    {{ ' ' }}
                    <span>{{ translateWord('Movido pelo Builderall.') }}</span>
                </h2>
            </div>
            <div
                class="t-stage"
                role="region"
                :aria-label="translateWord('Histórias de clientes')"
                tabindex="0"
                ref="stage"
            >
                <article
                    v-for="(card, index) in cards"
                    :key="card.name"
                    class="t-card"
                    :class="card.theme"
                    :style="isWide ? { '--o': index - active } : null"
                    :data-state="cardState(index)"
                    @click="onCardClick(index)"
                >
                    <figure>
                        <img :src="card.photo" alt="" width="430" height="440" loading="lazy">
                    </figure>
                    <blockquote>
                        <p v-for="(quote, quoteIndex) in card.quotes" :key="quoteIndex">{{ translateWord(quote) }}</p>
                        <cite><b>{{ card.name }}</b>{{ translateWord(card.role) }}</cite>
                    </blockquote>
                </article>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'PricingTestimonials',
    data() {
        return {
            active: 0,
            isWide: false
        };
    },
    computed: {
        ...mapGetters([
            'translateWord'
        ]),
        cards() {
            return [
                {
                    theme: 'theme-peach',
                    name: 'Claribel',
                    role: 'Dona de Agência',
                    photo: require('@/assets/images/testimonials/claribel.webp'),
                    quotes: [
                        '"Meus clientes não se importam com quantas ferramentas eu uso. Eles se importam que funcione.',
                        'O Builderall mantém meus sites, leads e follow-ups em um único lugar, e isso mudou a forma como eu administro meu negócio."'
                    ]
                },
                {
                    theme: 'theme-sky',
                    name: 'Jo Vasquez',
                    role: 'Criador de Conteúdo',
                    photo: require('@/assets/images/testimonials/jo-vasquez.webp'),
                    quotes: [
                        '"Eu quase desisti de lançar meu curso.',
                        'O Builderall foi a primeira vez que tudo funcionou junto de verdade, e eu finalmente fui ao ar."'
                    ]
                },
                {
                    theme: 'theme-blue',
                    name: 'Shawn',
                    role: 'Fundador de Startup',
                    photo: require('@/assets/images/testimonials/shawn.webp'),
                    quotes: [
                        '"Eu não queria cinco assinaturas só para lançar.',
                        'Com o Builderall, construí minhas landing pages e automações em uma única plataforma e me movi rápido. Essa velocidade importa."'
                    ]
                },
                {
                    theme: 'theme-orange',
                    name: 'Jhonn Vesga',
                    role: 'Mentor de Oratória e Dublador',
                    photo: require('@/assets/images/testimonials/jhonn-vesga.webp'),
                    quotes: [
                        '“Eu treino pessoas para se comunicarem com clareza quando mais importa — e precisava de uma plataforma que fizesse o mesmo.',
                        'A Builderall me permite administrar todo o meu ecossistema de mentoria em um só lugar, sem depender de várias ferramentas.”'
                    ]
                }
            ];
        }
    },
    created() {
        this.isWide = window.matchMedia('(min-width:901px)').matches;
    },
    mounted() {
        this.$nextTick(() => this.bindCarousel());
    },
    beforeDestroy() {
        this.teardownCarousel();
    },
    methods: {
        cardState(index) {
            if (!this.isWide) return null;
            return index === this.active ? 'active' : 'peek';
        },
        bindCarousel() {
            const stage = this.$refs.stage;
            const track = this.$refs.track;
            const panel = this.$refs.panel;
            if (!stage || !track || !panel) return;

            this._stage = stage;
            this._track = track;
            this._panel = panel;
            this._wide = window.matchMedia('(min-width:901px)');
            this._x0 = null;
            this._queued = false;
            this.isWide = this._wide.matches;

            this._onKeydown = (event) => {
                if (!this.isWide) return;
                if (event.key === 'ArrowRight') {
                    event.preventDefault();
                    this.go(this.active + 1);
                }
                if (event.key === 'ArrowLeft') {
                    event.preventDefault();
                    this.go(this.active - 1);
                }
            };
            this._onPointerDown = (event) => {
                this._x0 = event.clientX;
            };
            this._onPointerUp = (event) => {
                if (this._x0 === null || !this.isWide) return;
                const dx = event.clientX - this._x0;
                this._x0 = null;
                if (Math.abs(dx) > 40) this.go(this.active + (dx < 0 ? 1 : -1));
            };
            this._onScroll = () => {
                if (this._queued) return;
                this._queued = true;
                this._frame = window.requestAnimationFrame(() => this.fromScroll());
            };
            this._onWide = () => {
                this.isWide = this._wide.matches;
                this.fromScroll();
            };

            stage.addEventListener('keydown', this._onKeydown);
            stage.addEventListener('pointerdown', this._onPointerDown);
            stage.addEventListener('pointerup', this._onPointerUp);
            window.addEventListener('scroll', this._onScroll, { passive: true });
            window.addEventListener('resize', this._onScroll);
            if (this._wide.addEventListener) this._wide.addEventListener('change', this._onWide);
            else this._wide.addListener(this._onWide);

            this.fromScroll();
        },
        onCardClick(index) {
            if (this.isWide && index !== this.active) this.go(index);
        },
        go(index) {
            const count = this.cards.length;
            this.active = (index + count) % count;
        },
        fromScroll() {
            this._queued = false;
            if (!this.isWide || !this._track || !this._panel) return;
            const rect = this._track.getBoundingClientRect();
            const stick = parseFloat(getComputedStyle(this._panel).top) || 0;
            const runway = rect.height - this._panel.offsetHeight - stick;
            if (runway <= 0) return;
            let progress = (stick - rect.top) / runway;
            progress = progress < 0 ? 0 : (progress > 1 ? 1 : progress);
            let index = Math.floor(progress * this.cards.length);
            if (index > this.cards.length - 1) index = this.cards.length - 1;
            if (index !== this.active) this.go(index);
        },
        teardownCarousel() {
            if (this._frame) window.cancelAnimationFrame(this._frame);
            if (this._stage && this._onKeydown) {
                this._stage.removeEventListener('keydown', this._onKeydown);
                this._stage.removeEventListener('pointerdown', this._onPointerDown);
                this._stage.removeEventListener('pointerup', this._onPointerUp);
            }
            if (this._onScroll) {
                window.removeEventListener('scroll', this._onScroll);
                window.removeEventListener('resize', this._onScroll);
            }
            if (this._wide && this._onWide) {
                if (this._wide.removeEventListener) this._wide.removeEventListener('change', this._onWide);
                else this._wide.removeListener(this._onWide);
            }
            this._stage = null;
            this._track = null;
            this._panel = null;
        }
    }
};
</script>
